import {Component, OnInit} from '@angular/core';
import {TakeUntilDestroy} from '../services/take-until-destroy.decorator';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {CurrentMonthlyMembersModel, CurrentMonthlyMembersResult, PromoCode, UsersService} from '../swagger-codegen';
import {Observable} from 'rxjs';
import {ColumnSortedEvent, SortService} from '../sortable-column/sort-service';
import {finalize, takeUntil} from 'rxjs/operators';
import _ from 'lodash';
import {Functions} from '../services/functions';
import {saveAs} from 'file-saver';
import {ToastService} from '../services/toast.service';

@TakeUntilDestroy
@Component({
  selector: 'app-user-current-monthly',
  templateUrl: './user-current-monthly.component.html',
  styleUrls: ['./user-current-monthly.component.scss']
})
export class UserCurrentMonthlyComponent implements OnInit {
  @BlockUI()
  blockUI: NgBlockUI;
  componentDestroy: () => Observable<boolean>;
  public current: CurrentMonthlyMembersResult;
  sortEvent: ColumnSortedEvent = {sortColumn: 'Id', sortDirection: 'asc'};
  pageSize = 1000;
  previousPage = 1;
  currentPage = 1;
  totalPages = 0;
  sorted: CurrentMonthlyMembersModel[] = [];
  colectionSize = 0;

  constructor(private us: UsersService, private sortService: SortService, private toast: ToastService) {
  }

  ngOnInit(): void {
    this.blockUI.start();
    this.us.apiAdminUsersCurrentMonthlyMembersGet().pipe(finalize(this.blockUI.stop), takeUntil(this.componentDestroy()))
      .subscribe((result) => {
        this.current = result;
        this.colectionSize = result.count;
        this.sortEvent = {sortColumn: 'Id', sortDirection: 'asc'};
        this.sortByEvent();
      });
  }

  pageChanged(newPage: number): void {
    if (newPage !== this.previousPage) {
      this.previousPage = newPage;
      this.sortByEvent(newPage);
    }
  }


  public onSorted(event: ColumnSortedEvent): void {
    this.sortEvent = event;
    this.sortByEvent();
  }

  sortByEvent(currentPage: number = 1): void {
    if (this.sortEvent) {
      const startItem = (currentPage - 1) * this.pageSize;
      this.sorted = _.chain(this.current.users)
        .orderBy(this.sortEvent.sortColumn, this.sortEvent.sortDirection)
        .slice(startItem, startItem + this.pageSize).value();
      this.sortService.lastSortEvent = this.sortEvent;
    } else if (
      !this.sortEvent &&
      this.sortService.lastSortEvent
    ) {
      this.sortEvent = this.sortService.lastSortEvent;
      this.sortByEvent();
    }
  }

  export(): void {
    const header = ['id', 'firstName', 'lastName', 'email', 'code', 'authProfile',
      'status', 'currentPeriodStarted'];
    const headerTitles = ['Id', 'First Name', 'Last Name', 'Email', 'Code', 'AuthProfile',
      'Status', 'Current Period Started'];
    if (this.current.users.length) {
      const csv = _.map(_.orderBy(this.current.users, this.sortEvent.sortColumn, this.sortEvent.sortDirection),
        (row) => header.map(fieldName => {
          return Functions.typeSort(row, fieldName);
        }).join(','));
      csv.unshift(headerTitles.join(','));
      const csvArray = csv.join('\r\n');
      const blob = new Blob([csvArray], {type: 'text/csv'});
      saveAs(blob, `EquinEdgeUsersCurrentMonthly.csv`);
    } else {
      this.toast.error('you do not have any data.');
    }
  }
}
